import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Index",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Index.vue"),
    redirect: { name: "Deliver" },
  },
  {
    path: "/setting",
    name: "Setting",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Setting.vue"),
  },
  {
    path: "/deliver",
    name: "Deliver",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Deliver.vue"),
  },
];

// デザイン確認用のプレビューは **開発ビルドのみ**。 webpack が NODE_ENV を静的に
// 畳むので、 本番ビルドではこの push ごと (import 先のチャンクごと) 落ちる。
if (process.env.NODE_ENV !== "production") {
  routes.push({
    path: "/preview/competition",
    name: "PreviewCompetition",
    component: () =>
      import(
        /* webpackChunkName: "preview" */ "../views/PreviewCompetition.vue"
      ),
  });
  routes.push({
    path: "/preview/weather",
    name: "PreviewWeather",
    component: () =>
      import(/* webpackChunkName: "preview" */ "../views/PreviewWeather.vue"),
  });
  routes.push({
    path: "/preview/creative-qr",
    name: "PreviewCreativeQr",
    component: () =>
      import(
        /* webpackChunkName: "preview" */ "../views/PreviewCreativeQr.vue"
      ),
  });
}

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
